import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaLocationDot, FaPhone, FaWhatsapp } from "react-icons/fa6";
import Logo from "./Logo";
import { site, addressLine, whatsappUrl, mapsUrl, navLinks } from "../data/site";
import { trackEvent } from "../lib/analytics";

const servicios = [
  "Pivotes centrales",
  "Riego por aspersión",
  "Riego por goteo",
  "Alas regadoras",
  "Repuestos y service",
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-campo-950 text-campo-100/75">
      <div className="container-site py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Marca */}
          <div className="lg:col-span-1">
            <Logo variant="light" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed">
              {site.tagline}. Venta, asesoramiento, diseño e instalación en
              Villa Mercedes y toda la región.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href={site.social.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook de Riego Mercedes"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/[0.07] text-white transition-colors hover:bg-campo-700"
              >
                <FaFacebookF size={15} aria-hidden="true" />
              </a>
              <a
                href={site.social.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram de Riego Mercedes"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/[0.07] text-white transition-colors hover:bg-campo-700"
              >
                <FaInstagram size={15} aria-hidden="true" />
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp de Riego Mercedes"
                onClick={() => trackEvent("contact_click", { method: "whatsapp", location: "footer" })}
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/[0.07] text-white transition-colors hover:bg-[#25D366]"
              >
                <FaWhatsapp size={16} aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Navegación */}
          <nav aria-label="Enlaces del pie de página">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Navegación
            </h3>
            <ul className="mt-5 space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm transition-colors hover:text-white"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Servicios */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Servicios
            </h3>
            <ul className="mt-5 space-y-3">
              {servicios.map((servicio) => (
                <li key={servicio}>
                  <a
                    href="#servicios"
                    className="text-sm transition-colors hover:text-white"
                  >
                    {servicio}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Contacto
            </h3>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a
                  href={mapsUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-3 transition-colors hover:text-white"
                >
                  <FaLocationDot
                    className="mt-0.5 shrink-0 text-campo-500"
                    aria-hidden="true"
                  />
                  <span className="leading-relaxed">{addressLine}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:+${site.phoneRaw}`}
                  onClick={() => trackEvent("contact_click", { method: "phone", location: "footer" })}
                  className="flex items-center gap-3 transition-colors hover:text-white"
                >
                  <FaPhone className="shrink-0 text-campo-500" aria-hidden="true" />
                  {site.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => trackEvent("contact_click", { method: "whatsapp", location: "footer" })}
                  className="flex items-center gap-3 transition-colors hover:text-white"
                >
                  <FaWhatsapp className="shrink-0 text-[#25D366]" aria-hidden="true" />
                  WhatsApp
                </a>
              </li>
            </ul>

            <div className="mt-6 space-y-1 text-xs">
              {site.hours.map((h) => (
                <p key={h.days}>
                  <span className="text-campo-400">{h.days}:</span> {h.time}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-site flex flex-col items-center justify-between gap-3 py-6 text-xs sm:flex-row">
          <p>
            © {year} {site.name}. Todos los derechos reservados.
          </p>
          <p>
            {site.address.city}, {site.address.region} — Argentina
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
